import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ token, css }: any) => ({
  root: css`
    li,
    p {
      color: ${token.ColorFigmaNeutralGrayscaleGray90};
      font-size: ${token.BodyLargeFontSize};
      font-style: ${token.BodyLargeLetterSpacing};
      font-weight: ${token.BodyLargeFontWeight};
      line-height: ${token.BodyLargeLineHeight};
    }

    p {
      margin: 0;
      &:not(:last-child) {
        margin-bottom: 1rem;
      }
    }

    h1 {
      color: ${token.ColorFigmaNeutralGrayscaleGray90};
      font-size: ${token.BodyH700FontSize};
      font-style: ${token.BodyH700LetterSpacing};
      font-weight: ${token.BodyH700FontWeight};
      line-height: ${token.BodyH700LineHeight};

      margin: 0;
      &:not(:last-child) {
        margin-bottom: 0.4rem;
      }
    }

    h2 {
      color: ${token.ColorFigmaNeutralGrayscaleGray90};
      font-size: ${token.BodyH600FontSize};
      font-style: ${token.BodyH600LetterSpacing};
      font-weight: ${token.BodyH600FontWeight};
      line-height: ${token.BodyH600LineHeight};

      margin: 0;
      &:not(:last-child) {
        margin-bottom: 0.4rem;
      }
    }

    h3 {
      color: ${token.ColorFigmaNeutralGrayscaleGray90};
      font-size: ${token.BodyH500eFontSize};
      font-style: ${token.BodyH500LetterSpacing};
      font-weight: ${token.BodyH500FontWeight};
      line-height: ${token.BodyH500LineHeight};

      margin: 0;
      &:not(:last-child) {
        margin-bottom: 0.4rem;
      }
    }

    h4 {
      color: ${token.ColorFigmaNeutralGrayscaleGray90};
      font-size: ${token.BodyH400FontSize};
      font-style: ${token.BodyH400LetterSpacing};
      font-weight: ${token.BodyH400FontWeight};
      line-height: ${token.BodyH400LineHeight};

      margin: 0;
      &:not(:last-child) {
        margin-bottom: 0.4rem;
      }
    }

    strong {
      font-weight: ${token.BodyH300FontWeight};
    }
  `,
}));

export const useContentRendererStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
